import React from 'react';
import { arrayOf, bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionArticle.module.css';
import { Button, NamedLink, ExternalLink } from '../../../../components';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FormattedMessage } from '../../../../util/reactIntl';
import { APPLY_FOR_INVITE_URL } from '../../../../util/applyForInvite';

// Section component that's able to show article content
// The article content is mainly supposed to be inside a block
const SectionArticle = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
  } = props;
  const history = useHistory();
  const { currentUser } = useSelector(state => state.user);
  const userId =
    currentUser && currentUser.id && currentUser.id.uuid
      ? currentUser && currentUser.id && currentUser.id.uuid
      : '';
  const project = options?.projects;
  const onToggleFavorite = options?.onToggleFavorite;
  const isAuthenticated = options?.isAuthenticated;
  const isFeaturedListing = options?.isFeaturedListing;
  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields(
    [title, description, callToAction],
    fieldOptions
  );
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      projects={project}
      currentUser={currentUser}
      isFeaturedListing={isFeaturedListing}
      onToggleFavorite={onToggleFavorite}
      isAuthenticated={isAuthenticated}
      options={fieldOptions}
      blocks={blocks}
      title={title}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field
            data={title}
            className={defaultClasses.title}
            options={fieldOptions}
          />
          <Field
            data={description}
            className={defaultClasses.description}
            options={fieldOptions}
          />
          {sectionId === 'long-term-section' ? (
            currentUser?.id ? (
              <span className={css.applyButton}>Accept My Invitation</span>
            ) : (
              <ExternalLink
                className={css.applyButton}
                href={APPLY_FOR_INVITE_URL}
              >
                <FormattedMessage id="AuthenticationPage.signupLinkText" />
              </ExternalLink>
            )
          ) : (
            <Field
              data={callToAction}
              className={defaultClasses.ctaButton}
              options={fieldOptions}
            />
          )}
          {sectionId === 'invitation-section' ? (
            currentUser?.id ? (
              <span className={css.applyButton}>
                <FormattedMessage id="AuthenticationPage.signupLinkText" />
              </span>
            ) : (
              <ExternalLink
                className={css.applyButton}
                href={APPLY_FOR_INVITE_URL}
              >
                <FormattedMessage id="AuthenticationPage.signupLinkText" />
              </ExternalLink>
            )
          ) : (
            <Field
              data={callToAction}
              className={defaultClasses.ctaButton}
              options={fieldOptions}
            />
          )}
          {sectionId === 'travel-with-gfhr' ? (
            currentUser?.id ? (
              <span className={css.applyButton}>
                <FormattedMessage id="AuthenticationPage.signupLinkText" />
              </span>
            ) : (
              <ExternalLink
                className={css.applyButton}
                href={APPLY_FOR_INVITE_URL}
              >
                <FormattedMessage id="AuthenticationPage.signupLinkText" />
              </ExternalLink>
            )
          ) : (
            <Field
              data={callToAction}
              className={defaultClasses.ctaButton}
              options={fieldOptions}
            />
          )}
          {/* <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} /> */}
        </header>
      ) : null}
      {hasBlocks ? (
        <div
          className={classNames(
            defaultClasses.blockContainer,
            css.articleMain,
            {
              [css.noSidePaddings]: isInsideContainer,
            }
          )}
        >
          <BlockBuilder
            blocks={blocks}
            sectionId={sectionId}
            ctaButtonClass={defaultClasses.ctaButton}
            options={options}
          />
        </div>
      ) : null}
      {sectionId == 'community-section' && currentUser ? (
        <NamedLink
          className={css.inviteButton}
          name="InviteFamiliesPage"
          params={{ id: userId }}
        >
          Invite A Family
        </NamedLink>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionArticle.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  blocks: [],
  isInsideContainer: false,
  options: null,
};

SectionArticle.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  blocks: arrayOf(object),
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionArticle;
